import { apiClient } from '@/services/base'
import { useMutation, UseMutationResult } from '@tanstack/react-query'

import { IUpdatePasswordMultiTenantRequest } from './interfaces/request'
import { IUpdatePasswordMultiTenantResponse } from './interfaces/response'

export const UpdatePasswordMultiTenantService = async (
  request: IUpdatePasswordMultiTenantRequest,
): Promise<IUpdatePasswordMultiTenantResponse> => {
  const response = await apiClient.patch(
    'api/User/UpdatePasswordMultiTenantAsync',
    request,
  )

  return response?.data
}

export const useUpdatePasswordMultiTenantService = (): UseMutationResult<
  IUpdatePasswordMultiTenantResponse,
  Error,
  IUpdatePasswordMultiTenantRequest
> => {
  return useMutation<
    IUpdatePasswordMultiTenantResponse,
    Error,
    IUpdatePasswordMultiTenantRequest
  >({
    mutationFn: async (request) => {
      const response = await apiClient.patch(
        'api/User/UpdatePasswordMultiTenantAsync',
        request,
      )

      return response.data
    },
  })
}

export type {
  IUpdatePasswordMultiTenantRequest,
  IUpdatePasswordMultiTenantResponse,
}
